import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

class TabHeader extends PureComponent {
  render() {
    const { tabs } = this.props;
    return (
      <div className={cx('TabHeader')}>
        {tabs.map((tab, index) => {
          return (
            <a
              key={index}
              onClick={tab.onClick}
              className={cx({ active: tab.active })}
            >
              {tab.name}
            </a>
          );
        })}
      </div>
    );
  }
}

TabHeader.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      active: PropTypes.bool,
      onClick: PropTypes.func,
    }),
  ),
};

export default TabHeader;
